import { PartyAttorney } from './party-attorney';
import { SafeJSON } from './../../shared/safe-json';

export class Juvenile {
    private key: string;
    private json: any;
    private ncJoinNumber: string;
    // private fileStatus: string;

    constructor(key: string, json: any, ncJoinNumber: string) {
        this.key = key;
        this.json = json;
        this.ncJoinNumber = ncJoinNumber;
        // this.fileStatus = fileStatus;
    }

    getPartyKey(): string {
        return this.key;
    }


    getJuvenileName(): string {
        return SafeJSON.get('name', this.json);
    }

    getPartyType(): String {
        return SafeJSON.get('partyType', this.json);
    }

    getPartyNotes(): string {
        return SafeJSON.get('notes', this.json);
    }


    getPartyAliasList(): any[] {

        if (SafeJSON.get('partyAliasList', this.json) === '') {
            return [];
        }

        return SafeJSON.get('partyAliasList', this.json);

        /* let aliasList: string[];
         let list: any[] = SafeJSON.get('partyAliasList', this.json);
         for(const alias of list) {
             aliasList.push(alias.aliasName);
         }

         return aliasList;*/
    }

    getPartyPrimaryAddress(): string {
        let address = '';

        if (SafeJSON.get('primaryAddress', this.json) !== '') {
            address = address + SafeJSON.get('primaryAddress', this.json);
        }

        if (SafeJSON.get('primaryCity', this.json) !== '') {
            address = address + SafeJSON.get('primaryCity', this.json);
        }

        if (SafeJSON.get('primaryState', this.json) !== '') {
            address = address + SafeJSON.get('primaryState', this.json);
        }

        if (SafeJSON.get('primaryZipCode', this.json) !== '') {
            address = address + SafeJSON.get('primaryZipCode', this.json);
        }

        if (SafeJSON.get('primaryCountry', this.json) !== '') {
            address = address + SafeJSON.get('primaryCountry', this.json);
        }

        return address.trim();
    }

    getPrimaryAddress(): string {
        return SafeJSON.get('primaryAddress', this.json);
    }

    getPrimaryCity(): string {
        return SafeJSON.get('primaryCity', this.json);
    }

    getPrimaryState(): string {
        return SafeJSON.get('primaryState', this.json);
    }

    getPrimaryZipCode(): string {
        let zipCode: string = SafeJSON.get('primaryZipCode', this.json);
        if (zipCode.trim().length > 5) {
            return (zipCode.trim().substr(0, 5) + '-' + zipCode.trim().substr(5, zipCode.trim().length));
        } else {
            return zipCode;
        }
    }

    getPrimaryCountry(): string {
        return SafeJSON.get('primaryCountry', this.json);
    }

    isAddressPresent(): boolean {
        return ((this.getPartyPrimaryAddress() !== '') || (this.getPartySecondaryAddress() !== ''));
    }

    isPrimaryAddressExist(): boolean {
        return (this.getPartyPrimaryAddress() !== '');
    }

    isSecondaryAddressExist(): boolean {
        return (this.getPartySecondaryAddress() !== '');
    }


    getPartySecondaryAddress(): string {
        let address = '';

        if (SafeJSON.get('secondaryAddress', this.json) !== '') {
            address = address + SafeJSON.get('secondaryAddress', this.json);
        }

        if (SafeJSON.get('secondaryCity', this.json) !== '') {
            address = address + SafeJSON.get('secondaryCity', this.json);
        }

        if (SafeJSON.get('secondaryState', this.json) !== '') {
            address = address + SafeJSON.get('secondaryState', this.json);
        }

        if (SafeJSON.get('secondaryZipCode', this.json) !== '') {
            address = address + SafeJSON.get('secondaryZipCode', this.json);
        }

        if (SafeJSON.get('secondaryCountry', this.json) !== '') {
            address = address + SafeJSON.get('secondaryCountry', this.json);
        }

        return address.trim();
    }

    getSecondaryAddress(): string {
        return SafeJSON.get('secondaryAddress', this.json);
    }

    getSecondaryCity(): string {
        return SafeJSON.get('secondaryCity', this.json);
    }

    getSecondaryState(): string {
        return SafeJSON.get('secondaryState', this.json);
    }

    getSecondaryZipCode(): string {
        let zipCode: string = SafeJSON.get('secondaryZipCode', this.json);
        if (zipCode.trim().length > 5) {
            return (zipCode.trim().substr(0, 5) + '-' + zipCode.trim().substr(5, zipCode.trim().length));
        } else {
            return zipCode
        };
    }

    getSecondaryCountry(): string {
        return SafeJSON.get('secondaryCountry', this.json);
    }


    getPrimaryPhone(): string {
        return SafeJSON.get('primaryPhone', this.json);
    }

    getSecondaryPhone(): string {
        return SafeJSON.get('secondaryPhone', this.json);
    }

    getFaxNumber(): string {
        return SafeJSON.get('faxNumber', this.json);
    }

    getDateOfBirth(): string {
        return SafeJSON.get('birthDate', this.json);
    }

    getNCJoinNumber(): string {
        return this.ncJoinNumber;
    }

    getRace(): string {
        return SafeJSON.get('race', this.json);
    }

    getGender(): string {
        return SafeJSON.get('sex', this.json);
    }

    getCaseStatus(): string {
        let caseStatus = '';
        if (SafeJSON.get('inactiveFlag', this.json) !== '') {
            if (SafeJSON.get('inactiveFlag', this.json) === 'Y') {
                caseStatus = 'PREVIOUS';
            }

            if (SafeJSON.get('inactiveFlag', this.json) === 'N') {
                caseStatus = 'CURRENT';
            }
        }

        return caseStatus;
    }

    getPartyAttorneyList(): any[] {
        // sort list by last name and put primary attorney at beginning of list
        if (SafeJSON.get('partyAttorneyList', this.json) === '') {
            return [];
        }

        let partyAttorneyListUnsorted: PartyAttorney[] = [];
        // let partyAttorneyListUnsorted: PartyAttorney[] = <Array<PartyAttorney>>this.json.partyAttorneyList.values();
        let obj: any = SafeJSON.get('partyAttorneyList', this.json);
        Object.keys(obj).forEach(key => {
            partyAttorneyListUnsorted.push(new PartyAttorney(obj[key], key));
        })
        let partyAttorneyListSorted: PartyAttorney[] = [];
        let savePrimaryAttorney = undefined;

        // Sort this list by last name (note: this sorting requires a user defined object)
        partyAttorneyListUnsorted.sort(function (name1, name2) {
            if ((name1.getAttorneyName() < name2.getAttorneyName())) {
                return -1;
            } else if ((name1.getAttorneyName() > name2.getAttorneyName())) {
                return 1;
            } else {
                return 0;
            }
        });

        // Sort this list by assignment
        partyAttorneyListUnsorted.sort(function (name1, name2) {
            if ((name1.getAssignment() < name2.getAssignment())) {
                return -1;
            } else if ((name1.getAssignment() > name2.getAssignment())) {
                return 1;
            } else {
                return 0;
            }
        });

        // if we got multiple primary attorneys, just pick the first one we see to move to the top.
        for (const party of partyAttorneyListUnsorted) {
            const partyAttorneyItem = party;
            if (partyAttorneyItem.isAttorneyPrimary() === false || savePrimaryAttorney !== undefined) {
                partyAttorneyListSorted.push(partyAttorneyItem);
            } else {
                savePrimaryAttorney = partyAttorneyItem;
            }
        }

        if (savePrimaryAttorney !== undefined) {
            const finalPartyAttorneyListSorted: PartyAttorney[] = [];
            finalPartyAttorneyListSorted.push(savePrimaryAttorney);
            return finalPartyAttorneyListSorted.concat(partyAttorneyListSorted);
        }
        return partyAttorneyListSorted; // getting here means no primary attorney was indicated
    }

    // getFileStatus(): string {
    //     return this.fileStatus;
    // }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/juvenile.ts